import type { PropsWithChildren } from "react";
import { useSession } from "../auth/sessionContext";
import { InlineNotice } from "../components/Feedback/InlineNotice";
import { LEADCAT_COMMERCE_FEATURE } from "./commerceAccess";

export function CommerceTrackingRouteGuard({ children }: PropsWithChildren) {
  const session = useSession();
  const entitled = session.workspaceProduct !== "SIMPLE_BILLING"
    && session.features?.includes(LEADCAT_COMMERCE_FEATURE)
    && ["owner", "manager", "staff", "super_admin"].includes(session.user.role)
    && (session.user.role !== "super_admin" || Boolean(session.featureTenantId));
  if (!entitled) return <InlineNotice tone="error" title="Smart links unavailable">Select an entitled workspace or ask an owner for access.</InlineNotice>;
  return children;
}
